import { defineStyleConfig } from '@chakra-ui/react';

export const Table = defineStyleConfig({
  sizes: {},
  variants: {
    simple: {
      th: {
        color: 'black',
        fontSize: '16px',
      },
    },
  },
  defaultProps: {},
});
